import { StatusBadge } from '@/shared/components/ui/StatusBadge';
import { guideStatusToBadge, formatStatusLabel } from '@/shared/utils/statusBadge';

interface GuideStatusChipProps {
  status?: string;
  size?: 'small' | 'medium';
}

export function GuideStatusChip({ status, size = 'small' }: GuideStatusChipProps) {
  if (!status) return null;

  return (
    <StatusBadge
      status={guideStatusToBadge(status)}
      label={formatStatusLabel(status)}
      sx={size === 'medium' ? { fontSize: '0.75rem', py: 0.75 } : undefined}
    />
  );
}
